import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.CONSTANTS.XH * 4}px;
  width: 90%;
  background-color: ${({ theme }) => theme.THEME.background};
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 4}px;

  @media (min-width: 1025px) {
    width: 50%;
  }
`;

export const Title = styled.h1`
  font-family: "Sora", sans-serif;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 34}px;
  color: ${({ theme }) => theme.THEME.neonBlue};
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 4}px;
  text-align: center;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 10}px;
  }
`;

export const FieldGroup = styled.div`
  width: ${({ theme }) => theme.CONSTANTS.XW * 80}px;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 3}px;

  @media (min-width: 1025px) {
    width: ${({ theme }) => theme.CONSTANTS.XW * 35}px;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 3}px;
  flex-wrap: wrap;
  justify-content: center;
`;
